module.exports = __webpack_public_path__ + "static/fwh-logo-8f6cb2b88ed9fc163989453cf611cc51.png";